import { logoutUser } from './index';

const EXPIRED_TOKEN_PATTERNS = [
  'invalid or expired token'
];

let isLoggingOut = false;

function getErrorText(error) {
  const data = error && error.response && error.response.data;
  const parts = [
    data && data.message,
    data && data.error,
    error && error.message
  ];

  return parts
    .filter((value) => typeof value === 'string' && value.trim() !== '')
    .join(' ')
    .toLowerCase();
}

export function isExpiredTokenError(error) {
  const text = getErrorText(error);
  if (!text) {
    return false;
  }

  return EXPIRED_TOKEN_PATTERNS.some((pattern) => text.includes(pattern));
}

export function handleTokenRejected() {
  if (isLoggingOut) {
    return;
  }

  isLoggingOut = true;
  logoutUser();
}
